import React from 'react';
import {
  List,
} from '@material-ui/core';

import SingleListItem from './SingleListItem';
import SelectBoxes from './SelectBoxes';
import MultipleListItem from './MultipleListItem';


const singleList = ['sort'];
const selectBoxList = ['age', 'height'];


const filterList = (props) => {
  let list = null;

  if (singleList.includes(props.facet) && props.list) {
    list = props.list.map((item) => {
      return (
        <SingleListItem
          key={item.value}
          {...item}
          selectSingle={props.selectSingle}
          facet={props.facet}
        />
      );
    });
  } else if (selectBoxList.includes(props.facet)) {
    list = (
      <SelectBoxes
        selectSingle={props.selectSingle}
        facet={props.facet}
        activeFilters={props.activeFilters}
      />
    );
  } else if (props.list) {
    list = props.list.map((item) => {
      return (
        <MultipleListItem
          key={item.value}
          {...item}
          selectMultiple={props.selectMultiple}
          facet={props.facet}
          activeFilters={props.activeFilters}
        />
      );
    });
  }

  return (
    <List component="nav" style={{ width: '100%' }} disablePadding>
      {list}
    </List>
  );
};

export default filterList;



// WEBPACK FOOTER //
// ./src/search/components/FilterList.js